if ($('.ttgAnfrageFormular .recaptcha-consent').length) {
    $('.ttgAnfrageFormular .recaptcha-consent input[type="checkbox"]').on('change', function() {
        if ($(this).is(':checked')) {
            var sitekey = $(".ttgAnfrageFormular").find('.google-recaptcha').data('sitekey');
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?render=' + sitekey;
            script.setAttribute('defer', '');
            head.appendChild(script);
        }
    });
}

//Kataloge
if ($("#ttgKatalogForm .google-recaptcha").length) {
    $('#ttgKatalogForm .recaptcha-consent input[type="checkbox"]').on('change', function() {
        if ($(this).is(':checked')) {
            var sitekey = $("#ttgKatalogForm .google-recaptcha").data('sitekey');
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackKatalog&render=' + sitekey;
            script.setAttribute('defer', '');
            head.appendChild(script);
        }
    });
}

var onloadCallbackKatalog = function() {
    grecaptcha.ready(function() {
        grecaptcha.execute($("#ttgKatalogForm").find('.google-recaptcha').data('sitekey'), {
            action: 'submitKatalog'
        }).then(function(token) {
            $('#ttgKatalogForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
        });
    });
};
